import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Dialog } from '@mui/material';

import type { ActionItemSelection } from 'src/types/myFollowUp';
import useTicketDetailQuery from 'src/components/followUp/hooks/useTicketDetailQuery';
import ModalContentMain from 'src/components/followUp/TicketOverviewPage/TicketDetail/ModalContentMain';
import ModalSidebar from 'src/components/followUp/TicketOverviewPage/TicketDetail/Sidebar/ModalSidebar';
import useFollowUpTable from 'src/components/myFollowUp/MyFollowUpPage/FollowUpOverview/FollowUpTable/FollowUpTableContext';
import TicketDetailModalHeader from 'src/components/myFollowUp/MyFollowUpPage/FollowUpOverview/TicketDetailModal/TicketDetailModalHeader';
import { useSurveyDetailQuery } from 'src/components/survey/SurveySettings/api';

import { styles } from 'src/components/followUp/TicketOverviewPage/TicketDetail/ticketDetail.styles';

const TicketDetailModal: FC<{
  selectedTicketId: number | null;
  surveyId: number | null;
  onClose: () => void;
  enable: boolean;
  onRowSelect: (selectedRow: ActionItemSelection) => void;
}> = ({ selectedTicketId, surveyId, onClose, enable, onRowSelect }) => {
  const [open, setOpen] = useState(false);
  const { data: survey } = useSurveyDetailQuery(enable ? surveyId : null);
  const { refetch: refetchList } = useFollowUpTable();
  const { data: ticket, isFetching: loading } = useTicketDetailQuery(
    enable ? selectedTicketId : null,
  );

  useEffect(() => {
    if (!enable) return;

    setOpen(selectedTicketId !== null && surveyId !== null);
  }, [selectedTicketId, surveyId]);

  const closeModal = () => {
    setOpen(false);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={closeModal}
      maxWidth="xl"
      fullWidth
      sx={styles.modalRoot}
    >
      <TicketDetailModalHeader
        ticket={ticket}
        closeModal={closeModal}
        onRowSelect={onRowSelect}
      />
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: 0,
          flexGrow: 1,
        }}
      >
        {ticket ? (
          <>
            <ModalContentMain
              ticket={ticket}
              survey={survey}
              refetchList={refetchList}
            />
            <ModalSidebar
              ticket={ticket}
              loading={loading}
              refetchList={refetchList}
            />
          </>
        ) : (
          <Box
            sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}
          >
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Dialog>
  );
};
export default TicketDetailModal;
